import questionsTypes from '../types/questions';
import agentsTypes from "../types/agents";

const initialStore = {
    questionsList: [],
    questionsInfoList: [],
    commonQuestionsList: [],
    topic: 'POLICY',
    questionsTopicList: [],
    searchString: '',
    searchMatches: [],
    searchRequest: '',
    searchResults: [],
    itemToScroll: null,
    isLoadingQuestions: false,
};

const questionsStore = (state = initialStore, action) => {
    switch (action.type) {
        case questionsTypes.SET_QUESTIONS_LIST:
            return {
                ...state,
                questionsList: action.array,
            };
        case questionsTypes.SET_QUESTIONS_INFO_LIST:
            return {
                ...state,
                questionsInfoList: action.array,
            };
        case questionsTypes.SET_COMMON_QUESTIONS_LIST:
            return {
                ...state,
                commonQuestionsList: action.array,
            };
        case questionsTypes.SET_TOPIC:
            return {
                ...state,
                topic: action.string,
            };
        case questionsTypes.SET_QUESTIONS_TOPIC_LIST:
            return {
                ...state,
                questionsTopicList: action.array,
            };
        case questionsTypes.SET_SEARCH_STRING:
            return {
                ...state,
                searchString: action.string,
            };
        case questionsTypes.SET_SEARCH_MATCHES:
            return {
                ...state,
                searchMatches: action.matches,
            };
        case questionsTypes.SET_SEARCH_REQUEST:
            return {
                ...state,
                searchRequest: action.string,
            };
        case questionsTypes.SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: action.array,
            };
        case questionsTypes.SET_ITEM_TO_SCROLL:
            return {
                ...state,
                itemToScroll: action.object,
            };
        case questionsTypes.SET_LOADING_QUESTIONS:
            return {
                ...state,
                isLoadingQuestions: action.boolean,
            };
        default:
            return state;
    }
};

export default questionsStore;
